export const TRACKING = {
  create: {
    id: 'accountManagement.form.create',
    description: 'Account management create account',
  },
  update: {
    id: 'accountManagement.form.update',
    description: 'Account management update account',
  },
} as const
